module.exports = __webpack_public_path__ + "static/Customize-Banner-3b-e1403554305597-84ed53814bd67091faef9fe9462923d1.jpg";